import React from 'react';
import styled from 'styled-components';
import Icon from 'js/components/common/Icon';
import { upTo } from 'js/services/MediaQuery';

const Container = styled.div`
  grid-area: image;
  align-self: center;
  justify-self: center;
  padding-right: 1rem;
`;

const UserIcon = styled(Icon).attrs({ name: 'user-circle' })`
  font-size: 2rem;

  ${upTo('sm')`
    font-size: 1rem;
  `}
`;

const FacebookIcon = styled(Icon).attrs({ name: 'facebook-square' })`
  font-size: 2rem;

  ${upTo('sm')`
    font-size: 1rem;
  `}
`;

export default ({ type }) => <Container>{type === 'facebook' ? <FacebookIcon /> : <UserIcon />}</Container>;
